import basicController from "servicestack/basic.controller.properties";
import AutoQueryConfig from "servicestack/auto-query/auto-query.config";

export default class AutoQueryGroupByPanelController {
  constructor() {
    basicController(this);
    let $ctrl = this;
  }
  $onInit() {
    let $ctrl = this;
    if ($ctrl.hideEmptyGroupings === undefined)
      $ctrl.hideEmptyGroupings =
        $ctrl.filter.hideEmptyGroupings !== undefined
          ? $ctrl.filter.hideEmptyGroupings
          : AutoQueryConfig.hideEmptyGroupings === true;
    if ($ctrl.hideGroupingCounts === undefined)
      $ctrl.hideGroupingCounts =
        $ctrl.filter.hideGroupingCounts !== undefined
          ? $ctrl.filter.hideGroupingCounts
          : AutoQueryConfig.hideGroupingCounts === true;
    if ($ctrl.maxPanelHeight === undefined)
      $ctrl.maxPanelHeight = AutoQueryConfig.maxPanelHeight;
  }

  toggle(tag) {
    const $ctrl = this;
    $ctrl.filter.toggle(tag);
    $ctrl.onToggle && $ctrl.onToggle({ tag });
  }
}
